<template lang="pug">
  v-dialog(
    v-model="show",
    transition="slide-y-reverse-transition",
    persistent,
    max-width="450")
    v-card.pa-3
      v-card-title
        h4(class="display-1 mx-auto")  Новая организация
      v-card-text
        v-form(ref="forms" @submit.prevent="create")
          span(:class="{'upperLine-error': hasError}").upperLine Инн организации
          v-text-field(
            v-bind:class="{'has-error': hasError}",
            :rules="orgInnRules",
            ref="orgInn",
            outline,
            single-line,
            v-model="inn",
            maxlength="14",
            mask="##############",
            counter="14",
            autofocus,
            validate-on-blur,
            browser-autocomplete="off",
            type="text")
          span(:class="{'upperLine-error': hasError}").upperLine Название организации
          v-text-field(
            ref="orgName",
            v-bind:class="{'has-error': hasError}",
            :error-messages="error",
            :append-icon="isEditOrgName ? 'edit' : ''",
            :readonly="isEditOrgName ? false : true",
            outline,
            flat,
            single-line,
            v-model="showOrgName",
            :loading="loadingOrganisationInn",
            type="text")
      v-card-actions
        v-spacer
        v-btn(large @click.prevent="cancel").mx-3 Отмена
        v-btn(
          large
          color="primary",
          :disabled="disabled",
          @click.prevent="create").mx-3 Создать
        v-spacer
</template>

<script>
import axios from 'axios/index'
export default {
  name: 'AddOrganisation',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.subscribeToMutations()
  },
  data: () => ({
    inn: '',
    name: '',
    orgInnRules: [
      v => !!v || 'Необходимо ввести ИНН организации',
      v => (v && v.length > 13) || 'ИНН организации должен быть равен 14 цифрам'
    ],
    disabled: true,
    error: '',
    hasError: false,
    isEditOrgName: false
  }),
  watch: {
    inn(val) {
      this.error = ''
      this.hasError = false
      if (val && val.length === 14 && this.$refs.orgInn.validate()) {
        this.$store.dispatch('GET_ORGANISATION_INFO', val)
      }
      this.$store.state.employee.organisationInfo = ''
      this.name = ''
    },
    showOrgName(val) {
      this.disabled = val.length <= 0
    },
    isEditOrgName(val) {
      if (val) {
        this.$refs.orgName.focus()
      }
    }
  },
  computed: {
    loadingOrganisationInn() {
      return this.$store.state.employee.loading.organisationInn
    },
    showOrgName: {
      get() {
        return this.$store.state.employee.organisationInfo
      },
      set(val) {
        console.log(val)
        this.name = val
        this.disabled = val.length <= 0
      }
    }
  },
  methods: {
    cancel() {
      this.inn = ''
      this.name = ''
      this.$store.state.employee.organisationInfo = ''
      this.isEditOrgName = false
      this.$emit('close-dialog')
    },
    returnOrgName() {
      if (this.isEditOrgName) {
        return this.name
      } else {
        return this.$store.state.employee.organisationInfo
      }
    },
    create() {
      axios({
        method: 'POST',
        url: '/api/Organisation/create',
        data: { inn: this.inn, name: this.returnOrgName() }
      }).then(response => {
        console.log(response.data)
        this.cancel()
        this.$emit('update-organisation-list')
      }).catch(error => {
        console.log(error.response.data)
        this.hasError = true
        this.error = error.response.data.message
      })
    },
    subscribeToMutations() {
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'GET_ORGANISATION_NAME_FAILURE') {
          this.isEditOrgName = state.employee.errors.organisationInfoError.status === 404
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .v-btn {
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/OrganisationStructure/Organisation/AddOrganisation/AddOrganisation.vue